module.exports = __webpack_public_path__ + "static/media/blueSeed.211d7133.jpg";